/** Hero slider — exclusive generated imagery (not used elsewhere on site) */
export const HERO_SLIDES = [
  {
    title: 'Golden masterbatch pellets',
    path: 'images/hero/hero-slide-01-golden-pellets.png',
  },
  {
    title: 'Twin-screw compounding line',
    path: 'images/hero/hero-slide-02-compounding-line.png',
  },
  {
    title: 'Color measurement laboratory',
    path: 'images/hero/hero-slide-03-color-lab.png',
  },
  {
    title: 'Full color masterbatch spectrum',
    path: 'images/hero/hero-slide-04-color-spectrum.png',
  },
  {
    title: 'Recycled sustainable pellets',
    path: 'images/hero/hero-slide-05-recycled-pellets.png',
  },
  {
    title: 'Masterbatch production facility',
    path: 'images/hero/hero-slide-06-factory-interior.png',
  },
  {
    title: 'Pellet processing flow',
    path: 'images/hero/hero-slide-07-pellet-flow.png',
  },
  {
    title: 'Automotive polymer application',
    path: 'images/hero/hero-slide-08-automotive-application.png',
  },
];
